import React, { memo } from "react";
import { FaCheck } from "react-icons/fa";
import "./PendingAssignmentsList.css";

const PendingAssignmentsList = ({ pendingAssignments, onStartConfirm }) => {
  if (!pendingAssignments?.length) return null;

  return (
    <div className="pending-assignments-section">
      <div className="pending-assignments-header">
        <h3>הקצאות ממתינות לאישור ({pendingAssignments.length})</h3>
      </div>
      <div className="pending-assignments-list">
        {pendingAssignments.map((assignment) => (
          <div key={assignment.id} className="pending-assignment-item">
            <div className="assignment-info">
              <h4>הקצאה #{assignment.id.slice(-8)}</h4>
              <p>
                <strong>הוקצה על ידי:</strong>{" "}
                {assignment.firstAssignment.assignedByName}
              </p>
              <p>
                <strong>תאריך:</strong>{" "}
                {new Date(
                  assignment.firstAssignment.timestamp?.toDate?.() ||
                    assignment.firstAssignment.timestamp,
                ).toLocaleDateString("he-IL")}
              </p>
              <p>
                <strong>פריטים:</strong> {assignment.items.length}
              </p>
            </div>
            <div className="assignment-items">
              {assignment.items.map((item, index) => (
                <div key={index} className="assignment-item">
                  <span className="item-name">{item.itemName}</span>
                  {item.serial && (
                    <span className="item-serial">
                      מס&apos; סידורי: {item.serial}
                    </span>
                  )}
                  {item.quantity > 1 && (
                    <span className="item-quantity">כמות: {item.quantity}</span>
                  )}
                </div>
              ))}
            </div>
            <button
              type="button"
              className="confirm-assignment-btn"
              onClick={() => onStartConfirm(assignment.id)}
            >
              <FaCheck />
              אישר הקצאה
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(PendingAssignmentsList);
